// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_banner___mTYc","container":"banner_container__4Rb6h","left":"banner_left__YSmaB","btn":"banner_btn__aT17h","pic":"banner_pic__QS0_y"};